<template>
  <div class="yxtbiz-dept-tree-v3-bread-crumb" ref="bread-crumb">
    <div
      v-for="(item, index) in breadCrumbAndTagList"
      :key="index"
      :class="{
        'yxtbiz-dept-tree-v3-bread-crumb-tag': item.type === 'tag',
        'yxtbiz-dept-tree-v3-bread-crumb-item': item.type !== 'tag'
      }"
    >
      <div v-if="item.type === 'tag'">
        <span>&gt;</span>
      </div>
      <div v-else @click="handle(item, index)">{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    breadCrumbList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    breadCrumbAndTagList() {
      // 根据传入的面包屑数组动态生成间隔元素（2个元素之间插入一个tag）
      const breadCrumbAndTagList = [];
      for (let i = 0; i < this.breadCrumbList.length; i++) {
        breadCrumbAndTagList.push({ ...this.breadCrumbList[i] });
        if (i !== this.breadCrumbList.length - 1) {
          breadCrumbAndTagList.push({ type: 'tag' });
        }
      }
      return breadCrumbAndTagList;
    }
  },
  updated() {
    this.scrolltoRight(this.$refs['bread-crumb']);
  },
  methods: {
    scrolltoRight(el) {
      const { width } = el.getBoundingClientRect();
      el.scrollLeft = el.scrollWidth - width < 0 ? 0 : el.scrollWidth - width;
    },
    handle(item, index) {
      if (index === this.breadCrumbAndTagList.length - 1) return; // 最后一层不触发点击操作
      // 点击面包屑操作
      console.log(item, '12-312-3-12-31');
      this.$emit('click', item);
    }
  },
  mounted() {
    this.scrolltoRight(this.$refs['bread-crumb']);
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-dept-tree-v3 {
  &-bread-crumb {
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 10px;
    overflow-x: auto;
    background-color: #fff;
    user-select: none;

    &::-webkit-scrollbar {
      height: 0;
    }

    &-item {
      flex-shrink: 0;
      color: #436bff;
      font-size: 14px;
      line-height: 30px;

      &:last-child {
        color: #595959;
      }
    }

    &-tag {
      margin: 0 5px;

      span {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
